import React, { useState } from "react";
import Ripple from "../button/ripple";
import strings from "../../utils/property-file/employeeData.json";
import "./employeeData.css";
import { useForm } from "react-hook-form";
import moment from "moment";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import constants from "../../utils/constants";
import Select from "react-select";
import api from "../../services/api";
import { useEffect } from "react";
import SpinnerButton from "../button/spinnerButton";
import appStyles from "../../utils/appStyles";
import PropTypes from "prop-types";

export default function EmployeeData() {
  const [removeModalShow, setRemoveModalShow] = useState(false);
  const employeeId = localStorage.getItem(
    constants.localStorage.selectedEmployeeId
  );
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [detailsUpdating, setDetailsUpdating] = useState(false);
  const [loadingEmployeeDetails, setIsEmployeeLoadingDetails] = useState(true);
  const [updatedName, setUpdatedName] = useState("");
  const [updatedGender, setUpdatedGender] = useState("");
  const [updatedLocation, setUpdatedLocation] = useState("");
  const [updatedDob, setUpdatedDob] = useState("");
  const [updatedFatherName, setUpdatedFatherName] = useState("");
  const [updatedDesignation, setUpdatedDesignation] = useState("");
  const [updatedDepartment, setUpdatedDepartment] = useState("");
  const [updatedNationality, setUpdatedNationality] = useState("");
  const [updatedMaritalStatus, setUpdatedMaritalStatus] = useState("");
  const [updatedPhysicallyChallenged, setUpdatedPhysicallyChallenged] =
    useState("");
  const [updatedInternationalEmp, setUpdatedInternationalEmp] = useState("");
  const [updatedBloodGroup, setUpdatedBloodGroup] = useState("");
  const [updatedJoiningDate, setUpdatedJoiningDate] = useState("");
  const [earnLeaveCount , setEarnLeavesCount] = useState(null);
  const [sickLeaveCount , setSickLeavesCount] = useState(null);
  const [updatedContact, setUpdatedContact] = useState("");
  const [approversList, setApproversList] = useState(null);
  const [allApproverList, selectedAllApproverList] = useState();
  const [adminChange, setAdminChange] = useState(false);
  const [selectedEmploymentType, setSelectedEmploymentType] = useState(strings.selectOptionLabel);
  useEffect(() => {
    getApprovers();
  }, []);

  function updateValues(incomingData) {
    setUpdatedName(incomingData.name);
    setUpdatedGender(incomingData.gender);
    setUpdatedDob(incomingData.dateOfBirth);
    setUpdatedFatherName(incomingData.fathersName);
    setUpdatedDesignation(incomingData.designation);
    setUpdatedDepartment(incomingData.department);
    setUpdatedNationality(incomingData.nationality);
    setUpdatedMaritalStatus(incomingData.maritalStatus);
    setUpdatedPhysicallyChallenged(incomingData.physicallyChallenged);
    setUpdatedInternationalEmp(incomingData.internationalEmployee);
    setUpdatedBloodGroup(incomingData.bloodGroup);
    setUpdatedJoiningDate(incomingData.dateOfJoining);
    setUpdatedLocation(incomingData.location);
    setUpdatedInternationalEmp(incomingData.internationalEmployee);
    setUpdatedContact(incomingData.contact);
    setApproversList(incomingData.approvers);
    setSelectedEmploymentType(incomingData.employmentType);
    setEarnLeavesCount(incomingData.earnLeaveCount);
    setSickLeavesCount(incomingData.sickLeaveCount);
  }

  function SelectedApprovers(e) {
    let approverArr = [];
    e.map((val) => {
      let currentModule = val.value;
      approverArr.push(currentModule);
    });
    setApproversList(approverArr);
  }

  const editEmployeeDetails = async () => {
    setDetailsUpdating(true);
    try {
      let body = {
        _id: employeeId,
        name: updatedName,
        designation: updatedDesignation,
        department: updatedDepartment,
        location: updatedLocation,
        gender: updatedGender,
        dateOfBirth: updatedDob,
        fathersName: updatedFatherName,
        physicallyChallenged: updatedPhysicallyChallenged,
        internationalEmployee: updatedInternationalEmp,
        bloodGroup: updatedBloodGroup,
        dateOfJoining: updatedJoiningDate,
        maritalStatus: updatedMaritalStatus,
        nationality: updatedNationality,
        contact: updatedContact,
        approvers: approversList ? approversList : "",
        employmentType : selectedEmploymentType ? selectedEmploymentType : "",
        earnLeaveCount : earnLeaveCount || earnLeaveCount==0 ? parseInt(earnLeaveCount) : null,
        sickLeaveCount : sickLeaveCount || sickLeaveCount==0 ? parseInt(sickLeaveCount):null
      };
      const response = await api.editEmployee(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setDetailsUpdating(false);
          toast.success(
            data
              ? data.body
                ? data.body
                : strings.errorMessage
              : strings.errorMessage,
            { toastId: "error14" }
          );
          getEmployeeInformation();
        } else {
          toast.error(data.body, { toastId: "error6" });
          if (response.status_code === 440) {
            toast.error(
              data
                ? data.body
                  ? data.body
                  : strings.errorMessage
                : strings.errorMessage,
              { toastId: "error6" }
            );
            localStorage.clear();
            nav(constants.navigationLink.loginLink);
            setDetailsUpdating(false);
          }
          setDetailsUpdating(false);
        }
      } else {
        setDetailsUpdating(false);
      }
    } catch (error) {
      setDetailsUpdating(false);
    }
  };

  const getApprovers = async () => {
    try {
      const response = await api.getApproversInEmployeeProfile(employeeId);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          selectedAllApproverList(data.body ? data.body[0].approvers : null);
        } else {
          toast.error(data.body, { toastId: "error6" });
          selectedAllApproverList();
        }
      }
    } catch (error) {
      selectedAllApproverList();
      toast.error(strings.errorMessage, { toastId: "error6" });
    }
  };

  const {
    register,
    formState: { errors },
  } = useForm();
  const nav = useNavigate();

  const changeEmployeeType = async (id, empType) => {
    try {
      const body = {
        empUniqueId: id,
        isAdmin: empType === constants.constantRoles.adminLabel ? false : true,
      };
      const response = await api.changeEmpType(body);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          getEmployeeInformation();
          toast.success(data.body, { toastId: "error14" });
        } else {
          toast.error(data.body, { toastId: "error6" });
          if (response.status_code === 440) {
            localStorage.clear();
            nav(constants.navigationLink.loginLink);
          }
        }
        setAdminChange(false);
      }
    } catch (error) {
      toast.error(strings.errorMessage, { toastId: "error6" });
      setAdminChange(false);
    }
  };

  const getEmployeeInformation = async () => {
    try {
      const response = await api.getEmployeeInformation(employeeId);
      if (response && response.data) {
        const data = JSON.parse(response.data);
        if (response.success) {
          setEmployeeDetails(data.body);
          setIsEmployeeLoadingDetails(false);
          updateValues(data.body[0]);
        } else if (response.status_code === 440) {
          toast.error(data.body, { toastId: "error6" });
          localStorage.clear();
          setIsEmployeeLoadingDetails(false);
          nav(constants.navigationLink.loginLink);
        } else {
          setEmployeeDetails(null);
          toast.error(constants.localStorage.errorMessageLabel, {
            toastId: "error6",
          });
          setIsEmployeeLoadingDetails(false);
        }
      } else {
        setEmployeeDetails(null);
        setIsEmployeeLoadingDetails(false);
      }
    } catch (error) {
      setEmployeeDetails(null);
      setIsEmployeeLoadingDetails(false);
      toast.error(constants.localStorage.errorMessageLabel, {
        toastId: "error23",
      });
    }
  };

  useEffect(() => {
    getEmployeeInformation();
    getApprovers();
  }, []);

  const handleInput = (e) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
    }
  };

  const empTypeOptions = strings.empTypeList.map((empType) => ({
    value: empType,
    label: empType,
  }));
  console.log("employeeDetails",employeeDetails);
  

  return (
    <div className="emp-detail-main-container">
      <div className="emp-detail-sub-container mt-3">
        <div className="emp-data-container">
          <div className="add-emp-form-container">
            {loadingEmployeeDetails ? (
              <div className="loader-employee-information">
                <SpinnerButton />
              </div>
            ) : employeeDetails ? (
              <div>
                {employeeDetails.map((item,index) => {
                  return (
                    <div key={index}>
                      <div className=" justify-content-between align-items-center">
                        <div className="emp-header-part">
                          <div className="d-flex align-items-center upper-header-of-emp-detail">
                            <div className="employee-details-header-section">
                              <i
                                className="ri-arrow-left-line"
                                id="emp-data-back-arrow"
                                onClick={() => {
                                  nav(constants.navigationLink.backPage);
                                  localStorage.removeItem(
                                    constants.localStorage.selectedEmployeeId
                                  );
                                }}
                              ></i>
                              <div>
                                <span
                                  className="emp-data-previous-link"
                                  onClick={() => {
                                    nav(constants.navigationLink.backPage);
                                    localStorage.clearItem(
                                      constants.localStorage.selectedEmployeeId
                                    );
                                  }}
                                >
                                  {strings.employeeProfile}
                                </span>
                              </div>
                              <i
                                className="ri-arrow-right-s-line"
                                id="emp-data-inline-link-separator"
                              ></i>
                              <div>
                                <span className="active-inline-link">
                                  {item.name}
                                </span>
                              </div>
                            </div>
                            <div className="employment-type">
                              <Select
                                value={
                                  selectedEmploymentType
                                    ? {
                                        value: selectedEmploymentType,
                                        label: selectedEmploymentType,
                                      }
                                    : null
                                }
                                options={empTypeOptions}
                                styles={appStyles.employeeProfileDropdown}
                                isDisabled={!item.isActive}
                                onChange={(selectedOption) => {
                                  setSelectedEmploymentType(
                                    selectedOption.value
                                  );
                                }}
                                placeholder={strings.selectOptionLabel}
                                isSearchable={false}
                              />
                            </div>
                          </div>
                          <div className="toggle-image-container">
                            <form encType="multipart/form-data">
                              <label htmlFor="fileToUpload">
                                {item.profilePic ? (
                                  <div>
                                    <img
                                      className="add-emp-img-selected"
                                      src={item.profilePic}
                                    />
                                  </div>
                                ) : (
                                  <div>
                                    <i
                                      className="ri-user-3-line"
                                      id="emp-data-user-icon"
                                    ></i>
                                  </div>
                                )}
                              </label>
                            </form>
                            <div className="admin-toggle">
                              <p>{strings.makeAdminStatement}</p>
                              <div className="checkbox-wrapper-3 display-center">
                                <input
                                  type="checkbox"
                                  id="cbx-3"
                                  disabled={adminChange}
                                  defaultChecked={
                                    item.empType ===
                                    constants.constantRoles.adminLabel
                                  }
                                  onChange={() => {
                                    changeEmployeeType(item._id, item.empType);
                                    setAdminChange(true);
                                  }}
                                />
                                <label htmlFor="cbx-3" className="toggle">
                                  <span></span>
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="employee-whole-information">
                        <div className="employee-details-heading mt-2">
                          <h5>{strings.empDetHead}</h5>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empName", {
                              required: strings.empNameValidation,
                              minLength: {
                                value: 2,
                                message: strings.minCharError,
                              },
                              maxLength: 30,
                              pattern: {
                                value: /^[a-z A-Z ]*$/,
                                message: strings.alphabetsOnly,
                              },
                            })}
                            type="text"
                            className={
                              errors.empName
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            placeholder=" "
                            autoComplete="off"
                            value={updatedName}
                            onChange={(e) => {
                              setUpdatedName(e.target.value);
                            }}
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.Name}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empName && (
                                <span>
                                  <strong>&#9432;;</strong>
                                  {errors.empName.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("email", {
                              required: strings.emailValidation,
                              pattern: {
                                value:
                                  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                message: strings.emailValidate,
                              },
                            })}
                            type="email"
                            value={item.email}
                            disabled={!item.isActive}
                            className={
                              errors.email
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            placeholder=" "
                            autoComplete="off"
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.emailAddress}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.email && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {errors.email.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empID", {
                              required: true,
                              maxLength: {
                                value: 10,
                                message: strings.empIdValidate,
                              },
                            })}
                            type="text"
                            className={
                              errors.empID
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={item.empId}
                            placeholder=" "
                            autoComplete="off"
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empId}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empID && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empIDValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empType", {
                              required: true,
                              maxLength: {
                                value: 10,
                                message: strings.empIdValidate,
                              },
                            })}
                            type="text"
                            className={
                              errors.empType
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={item.empType}
                            placeholder=" "
                            autoComplete="off"
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empType}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empType && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empIDValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empContact", {
                              required: true,

                              maxLength: {
                                value: 10,
                                message: strings.empIdValidate,
                              },
                            })}
                            type="text"
                            className={
                              errors.empType
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={updatedContact}
                            onChange={(e) => {
                              setUpdatedContact(e.target.value);
                            }}
                            placeholder=" "
                            autoComplete="off"
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empContact}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empType && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empIDValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <div>
                            <label className="emp-data-select-box-label mb-2">
                              {strings.empGender}
                            </label>
                            <select
                              {...register("empGender", { required: true })}
                              className={
                                errors.empGender
                                  ? "bg-transparent emp-data-select-dropdown emp-det-error pt-0 pb-2"
                                  : "bg-transparent emp-data-select-dropdown pt-0 pb-2"
                              }
                              value={updatedGender}
                              onChange={(e) => {
                                setUpdatedGender(e.target.value);
                              }}
                              disabled={!item.isActive}
                            >
                              {strings.empGenderList.map((item ,index) => {
                                return (
                                  <option id="dropdown-label" key={index}>{item}</option>
                                );
                              })}
                            </select>
                            <div className="form-validation">
                              <small>
                                {errors.empGender && (
                                  <span>
                                    <strong>&#9432;</strong>
                                    {strings.empTypeValidation}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empDob", { required: true })}
                            type="date"
                            id="empDob"
                            className={
                              errors.empDob
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            placeholder=" "
                            autoComplete="off"
                            max={moment().format("YYYY-MM-DD")}
                            value={updatedDob}
                            onChange={(e) => {
                              setUpdatedDob(e.target.value);
                            }}
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empDob}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empDob && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empDOBValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empFathers", {
                              required: strings.empFathersName,
                              minLength: {
                                value: 2,
                                message: strings.minCharError,
                              },
                              maxLength: 50,
                              pattern: {
                                value: /^[a-z A-Z ]*$/,
                                message: strings.alphabetsOnly,
                              },
                            })}
                            type="text"
                            className={
                              errors.empFathers
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={updatedFatherName}
                            onChange={(e) => {
                              setUpdatedFatherName(e.target.value);
                            }}
                            disabled={!item.isActive}
                            placeholder=" "
                            autoComplete="off"
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empFather}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empFathers && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {errors.empFathers.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empLoc", {
                              required: strings.empFathersName,
                              minLength: {
                                value: 2,
                                message: strings.minCharError,
                              },
                              maxLength: 50,
                              pattern: {
                                value: /^[a-z A-Z ]*$/,
                                message: strings.alphabetsOnly,
                              },
                            })}
                            type="text"
                            className={
                              errors.empLoc
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={updatedLocation}
                            onChange={(e) => {
                              setUpdatedLocation(e.target.value);
                            }}
                            disabled={!item.isActive}
                            placeholder=" "
                            autoComplete="off"
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empLoc}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empLoc && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {errors.empLoc.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empDes", {
                              required: strings.empDesValidation,
                              minLength: {
                                value: 2,
                                message: strings.minCharError,
                              },
                              maxLength: 30,
                              pattern: {
                                value: /^[a-z A-Z ]*$/,
                                message: strings.alphabetsOnly,
                              },
                            })}
                            type="text"
                            className={
                              errors.empDes
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={updatedDesignation}
                            onChange={(e) => {
                              setUpdatedDesignation(e.target.value);
                            }}
                            placeholder=" "
                            autoComplete="off"
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empDes}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empDes && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {errors.empDes.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("empDept", {
                              required: strings.empDeptValidation,
                              minLength: {
                                value: 2,
                                message: strings.minCharError,
                              },
                              maxLength: 50,
                              pattern: {
                                value: /^[a-z A-Z ]*$/,
                                message: strings.alphabetsOnly,
                              },
                            })}
                            type="text"
                            className={
                              errors.empDept
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={updatedDepartment}
                            onChange={(e) => {
                              setUpdatedDepartment(e.target.value);
                            }}
                            placeholder=" "
                            autoComplete="off"
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empDept}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empDept && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {errors.empDept.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>

                        <div className="form-floating side-gap">
                          <input
                            {...register("empNat", {
                              required: strings.empNatValidation,
                              minLength: {
                                value: 2,
                                message: strings.minCharError,
                              },
                              maxLength: 50,
                              pattern: {
                                value: /^[a-z A-Z ]*$/,
                                message: strings.alphabetsOnly,
                              },
                            })}
                            type="text"
                            className={
                              errors.empNat
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            value={updatedNationality}
                            onChange={(e) => {
                              setUpdatedNationality(e.target.value);
                            }}
                            placeholder=" "
                            autoComplete="off"
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.empNat}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.empNat && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {errors.empNat.message}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <div>
                            <label className="emp-data-select-box-label mb-2">
                              {strings.empMaritalStatus}
                            </label>
                            <select
                              {...register("empMarital", { required: true })}
                              className={
                                errors.empMarital
                                  ? "bg-transparent emp-data-select-dropdown emp-det-error pt-0 pb-2"
                                  : "bg-transparent emp-data-select-dropdown pt-0 pb-2"
                              }
                              value={updatedMaritalStatus}
                              disabled={!item.isActive}
                              onChange={(e) => {
                                setUpdatedMaritalStatus(e.target.value);
                              }}
                            >
                              {strings.maritalStatus.map((item ,index) => {
                                return (
                                  <option id="dropdown-label" key={index}>{item}</option>
                                );
                              })}
                            </select>
                            <div className="form-validation">
                              <small>
                                {errors.empMarital && (
                                  <span>
                                    <strong>&#9432;</strong>
                                    {strings.requiredFieldLabel}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <div>
                            <label className="emp-data-select-box-label mb-2">
                              {strings.phyChallenged}
                            </label>
                            <select
                              {...register("empPhysical", { required: true })}
                              className={
                                errors.empPhysical
                                  ? "bg-transparent emp-data-select-dropdown emp-det-error pt-0 pb-2"
                                  : "bg-transparent emp-data-select-dropdown pt-0 pb-2"
                              }
                              value={updatedPhysicallyChallenged}
                              onChange={(e) => {
                                setUpdatedPhysicallyChallenged(e.target.value);
                              }}
                              disabled={!item.isActive}
                            >
                              {strings.yesNoOption.map((item ,index) => {
                                return (
                                  <option id="dropdown-label" key={index}>{item}</option>
                                );
                              })}
                            </select>
                            <div className="form-validation">
                              <small>
                                {errors.empPhysical && (
                                  <span>
                                    <strong>&#9432;</strong>
                                    {strings.requiredFieldLabel}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <div>
                            <label className="emp-data-select-box-label mb-2">
                              {strings.empInternational}
                            </label>
                            <select
                              {...register("empInternational", {
                                required: true,
                              })}
                              className={
                                errors.empInternational
                                  ? "bg-transparent emp-data-select-dropdown emp-det-error pt-0 pb-2"
                                  : "bg-transparent emp-data-select-dropdown pt-0 pb-2"
                              }
                              value={updatedInternationalEmp}
                              onChange={(e) => {
                                setUpdatedInternationalEmp(e.target.value);
                              }}
                              disabled={!item.isActive}
                            >
                              {strings.yesNoOption.map((item ,index) => {
                                return (
                                  <option id="dropdown-label" key={index}>{item}</option>
                                );
                              })}
                            </select>
                            <div className="form-validation">
                              <small>
                                {errors.empInternational && (
                                  <span>
                                    <strong>&#9432;</strong>
                                    {strings.empDeptValidation}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <div>
                            <label className="emp-data-select-box-label mb-2">
                              {strings.bloodGroup}
                            </label>
                            <select
                              {...register("bloodGroup", { required: true })}
                              className={
                                errors.bloodGroup
                                  ? "bg-transparent emp-data-select-dropdown emp-det-error pt-0 pb-2"
                                  : "bg-transparent emp-data-select-dropdown pt-0 pb-2"
                              }
                              value={updatedBloodGroup}
                              onChange={(e) => {
                                setUpdatedBloodGroup(e.target.value);
                              }}
                              disabled={!item.isActive}
                            >
                              {strings.bloodGroupOption.map((item ,index) => {
                                return (
                                  <option id="dropdown-label" key={index}>{item}</option>
                                );
                              })}
                            </select>
                            <div className="form-validation">
                              <small>
                                {errors.bloodGroup && (
                                  <span>
                                    <strong>&#9432;</strong>
                                    {strings.requiredFieldLabel}
                                  </span>
                                )}
                              </small>
                            </div>
                          </div>
                        </div>
                        <div className="form-floating side-gap">
                          <input
                            {...register("joiningDate", { required: true })}
                            type="date"
                            id="joining-date"
                            className={
                              errors.joiningDate
                                ? "form-control validateEmail email-input input-text-alert add-employee-input-text"
                                : "form-control validateEmail email-input add-employee-input-text"
                            }
                            placeholder=" "
                            autoComplete="off"
                            max={moment().format("YYYY-MM-DD")}
                            value={updatedJoiningDate}
                            onChange={(e) => {
                              setUpdatedJoiningDate(e.target.value);
                            }}
                            disabled={!item.isActive}
                          />
                          <label
                            htmlFor="floating-input"
                            className="input-label"
                          >
                            {strings.joinDate}
                          </label>
                          <div className="form-validation">
                            <small>
                              {errors.joiningDate && (
                                <span>
                                  <strong>&#9432;</strong>
                                  {strings.empJDValidation}
                                </span>
                              )}
                            </small>
                          </div>
                        </div>

                        <div className="side-gap">
                        <label
                            className="employee-earn-leave-label"
                          >
                            {strings.earnLeaveLabel}
                          </label>
                          <input className="employee-earn-leave" type="number" value={earnLeaveCount} onChange={((e)=>setEarnLeavesCount(e.target.value))} onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} maxLength="2" onInput={handleInput} placeholder={strings.enterEarnLabel}/>
                        </div>
                        <div className="side-gap">
                        <label
                            className="employee-earn-leave-label"
                          >
                            {strings.sickLeaveLabel}
                          </label>
                          <input className="employee-earn-leave" type="number" value={sickLeaveCount} onChange={((e)=>setSickLeavesCount(e.target.value))} onKeyDown={(evt) => ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()} maxLength="2" onInput={handleInput} placeholder={strings.enterSickLabel}/>
                        </div>

                        <div className="common-approver form-floating side-gap">
                        <div className="approvers-label">
                                {strings.approversLabel}
                        </div>
                          <Select
                            defaultValue={
                              approversList
                                ? approversList.map((item) => ({
                                    value: item._id,
                                    label: item.name,
                                  }))
                                : ""
                            }
                            isDisabled={!item.isActive}
                            options={allApproverList}
                            styles={appStyles.companyProfileDropdown}
                            placeholder="Assign approvers"
                            onChange={SelectedApprovers}
                            isMulti
                            className="react-select-emp-profile"
                          />
                        </div>
                        <div className="form-floating side-gap">
                          <div className="add-emp-schedule-heading">
                            <div className="row">
                              <div className="col-7">
                                <h2>{strings.leaveDetails}</h2>
                              </div>
                              
                            </div>
                            <div className="schedule-list">
                              <div className="leaves-details-of-employee">
                              <div>{strings.totalLeave}{item.sickLeaveCount && item.earnLeaveCount ? item.sickLeaveCount + item.earnLeaveCount :0}</div>
                              <div>{strings.pendingLeaves}{item.pendingLeave ? item.pendingLeave : 0}</div>
                              <div>{strings.earnedLeave} {item.earnLeaveCount ? item.earnLeaveCount : 0}</div>
                              <div>{strings.pendingEarnedLeave}{item.pendingEarnLeave ? item.pendingEarnLeave : 0}</div>
                              <div>{strings.sickLeave} {item.sickLeaveCount?item.sickLeaveCount:0}</div>
                              <div>{strings.pendingSickLeave} {item.pendingSickLeave?item.pendingSickLeave: 0}</div>
                              </div>
                              {item.isActive && (
                                <div className="emp-det-btn-alignment mt-4">
                                  <div>
                                    <button
                                      className="btn btn-outline-danger emp-btn-remove-emp"
                                      onClick={() => setRemoveModalShow(true)}
                                      disabled={
                                        item.isActive === true ? false : true
                                      }
                                    >
                                      <Ripple duration={1000} />
                                      {strings.removeEmployee}
                                    </button>
                                    <RemoveEmployeeModal
                                      show={removeModalShow}
                                      onHide={() => setRemoveModalShow(false)}
                                      empName={item.name}
                                      empId={item._id}
                                      empGetInfoApi={getEmployeeInformation}
                                    />
                                    <button
                                      className="btn btn-outline-danger emp-btn-remove-emp-responsive"
                                      onClick={() => setRemoveModalShow(true)}
                                      disabled={
                                        item.isActive === true ? false : true
                                      }
                                    >
                                      <i className="ri-delete-bin-2-line"></i>
                                      <Ripple duration={1000} />
                                    </button>
                                  </div>
                                  <div className="emp-det-btn-aligned-btns">
                                   
                                    <button
                                      className="btn btn-secondary emp-det-discard-btn"
                                      onClick={() => {
                                        getApprovers();
                                        getEmployeeInformation();
                                      }}
                                      disabled={
                                        updatedName === item.name &&
                                        updatedContact === item.contact &&
                                        updatedDesignation ===
                                          item.designation &&
                                        updatedDepartment === item.department &&
                                        updatedLocation === item.location &&
                                        updatedGender === item.gender &&
                                        updatedDob === item.dateOfBirth &&
                                        updatedFatherName ===
                                          item.fathersName &&
                                        updatedPhysicallyChallenged ===
                                          item.physicallyChallenged &&
                                        updatedInternationalEmp ===
                                          item.internationalEmployee &&
                                        updatedBloodGroup === item.bloodGroup &&
                                        updatedJoiningDate ===
                                          item.dateOfJoining &&
                                        updatedMaritalStatus ===
                                          item.maritalStatus &&
                                        updatedNationality ===
                                          item.nationality &&
                                        approversList === item.approvers &&
                                        selectedEmploymentType === item.employmentType &&
                                        earnLeaveCount == item.earnLeaveCount &&
                                        sickLeaveCount == item.sickLeaveCount
                                      }
                                    >
                                      <Ripple duration={1000} />
                                      {strings.discard}
                                    </button>
                                    <button
                                      className="btn btn-primary emp-det-save-changes"
                                      onClick={editEmployeeDetails}
                                      disabled={
                                        updatedName === item.name &&
                                        updatedContact === item.contact &&
                                        updatedDesignation ===
                                          item.designation &&
                                        updatedDepartment === item.department &&
                                        updatedLocation === item.location &&
                                        updatedGender === item.gender &&
                                        updatedDob === item.dateOfBirth &&
                                        updatedFatherName ===
                                          item.fathersName &&
                                        updatedPhysicallyChallenged ===
                                          item.physicallyChallenged &&
                                        updatedInternationalEmp ===
                                          item.internationalEmployee &&
                                        updatedBloodGroup === item.bloodGroup &&
                                        updatedJoiningDate ===
                                          item.dateOfJoining &&
                                        updatedMaritalStatus ===
                                          item.maritalStatus &&
                                        updatedNationality ===
                                          item.nationality &&
                                        approversList === item.approvers && 
                                        selectedEmploymentType === item.employmentType &&
                                        earnLeaveCount == item.earnLeaveCount &&
                                        sickLeaveCount == item.sickLeaveCount
                                      }
                                    >
                                      <Ripple duration={1000} />
                                      <p className="emp-btn-save-changes">
                                        {detailsUpdating ? (
                                          <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                          >
                                            <span className="sr-only"></span>
                                          </div>
                                        ) : (
                                          strings.saveChanges
                                        )}
                                      </p>
                                      <p className="emp-btn-save">
                                        {detailsUpdating ? (
                                          <div
                                            className="spinner-border spinner-border-sm text-light"
                                            role="status"
                                          >
                                            <span className="sr-only"></span>
                                          </div>
                                        ) : (
                                          strings.save
                                        )}
                                      </p>
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function RemoveEmployeeModal(props) {
  const [removedEmployee, setRemovedEmployee] = useState(false);
  const nav = useNavigate();
  const removingEmployee = async (e) => {
    setRemovedEmployee(true);
    e.preventDefault();
    try {
      let body = {
        id: props.empId,
      };
      const response = await api.removeEmployee(body);
      if (response) {
        if (response.success) {
          const data = JSON.parse(response.data);
          toast.success(
            data
              ? data.body
                ? data.body
                : strings.errorMessage
              : strings.errorMessage,
            { toastId: "error56" }
          );
          setRemovedEmployee(false);
          nav(constants.navigationLink.empProfile);
          props.onHide();
          props.empGetInfoApi();
        } else if (response.status_code === 440) {
          const data = JSON.parse(response.data);
          setRemovedEmployee(false);
          localStorage.clear();
          toast.error(
            data
              ? data.body
                ? data.body
                : strings.errorMessage
              : strings.errorMessage,
            { toastId: "error52" }
          );
          nav(constants.navigationLink.loginLink);
        }
      }
    } catch (error) {
      setRemovedEmployee(false);
      nav(constants.navigationLink.serverDown);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      id="modal"
      centered
      className="emp-det-filter-modal"
    >
      <Modal.Header id="emp-det-remove-modal-title">
        <Modal.Title>
          <span>{strings.removeEmployee}</span>
          <button className="btn-close-modal" onClick={props.onHide}>
            <i className="ri-close-fill"></i>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="emp-data-remove-emp-body">
        <div>
          <div className="row">
            <form>
              <div>
                <i
                  className="ri-delete-bin-6-line"
                  id="emp-data-remove-emp-icon"
                ></i>
              </div>
              <div className="mt-5">
                <p className="emp-data-remove-emp-statement mb-4">
                  {strings.statementRemove}
                  {props.empName}
                </p>
                <center>
                  {removedEmployee ? (
                    <button
                      type="submit"
                      className=" btn btn-danger emp-det-remove-btn"
                      data-bs-dismiss="modal"
                      disabled
                    >
                      <div
                        className="spinner-border spinner-border-sm text-light"
                        role="status"
                      >
                        <span className="sr-only"></span>
                      </div>
                    </button>
                  ) : (
                    <button
                      type="submit"
                      className=" btn btn-danger emp-det-remove-btn"
                      data-bs-dismiss="modal"
                      onClick={removingEmployee}
                    >
                      <Ripple duration={1000} />
                      {strings.removeEmp}
                    </button>
                  )}
                </center>
              </div>
            </form>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

RemoveEmployeeModal.propTypes = {
  empId: PropTypes.any.isRequired,
  onHide : PropTypes.func.isRequired,
  empGetInfoApi : PropTypes.func.isRequired,
  empName : PropTypes.any.isRequired
};